module.exports = __webpack_public_path__ + "img/receipt.6a5f5061.svg";